import { ChangeDetectionStrategy, Component, inject, computed } from '@angular/core'
import { RouterLink } from '@angular/router'
import { IAlertCard } from '@app/core/models/dashboard.model'
import { SalesFunnelService } from '@core/services/sales-funnel/sales-funnel.service'
import { valueConstants } from '@app/core/constants/valueConstants'
import { SalesFunnelHelper } from '@app/core/helpers/sales-funnel.helper'
import { EStageId } from '@app/core/enum/sales-funnel.enum'
import { LEAD_DASHBOARD_QUERY_PARAMS, FUNNEL_SOURCE_HOME } from '@app/core/constants/app.constants'

@Component({
    selector: 'app-alerts-strip',
    templateUrl: './alerts-strip.component.html',
    styleUrls: ['./alerts-strip.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink],
})
export class AlertsStripComponent {
    private readonly salesFunnelService = inject(SalesFunnelService)

    readonly alertSkeletonItems = [1, 2, 3]
    readonly valueConstants = valueConstants

    readonly isLoading = computed(() => this.salesFunnelService.isLoading())
    readonly keyMetrics = this.salesFunnelService.keyMetrics

    readonly alerts = computed(() => {
        const keyMetrics = this.keyMetrics()
        const alertCards: IAlertCard[] = []

        // Critical Approvals hidden — users reach Proposal Approvals via sidebar menu only.
        // alertCards.push({
        //     title: this.valueConstants.CRITICAL_APPROVALS,
        //     value: this._criticalApprovalsTotal(),
        //     emphasis: true,
        // })

        const s3Count = keyMetrics?.leads_stuck_in_s3 ?? 0
        const s4Count = keyMetrics?.leads_stuck_in_s4 ?? 0
        const s6Count = keyMetrics?.leads_stuck_in_s6 ?? 0

        if (keyMetrics) {
            alertCards.push({
                title: 'No movement S3 → S4 in 10 days',
                value: s3Count,
                emphasis: false,
                leadIds: keyMetrics.leads_stuck_in_s3_lead_ids,
            })

            alertCards.push({
                title: 'No movement S4 → S5 in 15 days',
                value: s4Count,
                emphasis: false,
                leadIds: keyMetrics.leads_stuck_in_s4_lead_ids,
            })

            alertCards.push({
                title: `No movement S6 → ${SalesFunnelHelper.getStageDisplayCode(EStageId.DEAL_WON)} in 20 days`,
                value: s6Count,
                emphasis: false,
                leadIds: keyMetrics.leads_stuck_in_s6_lead_ids,
            })
        } else {
            alertCards.push({
                title: 'No movement S3 → S4 in 10 days',
                value: 0,
                emphasis: false,
            })

            alertCards.push({
                title: 'No movement S4 → S5 in 15 days',
                value: 0,
                emphasis: false,
            })

            alertCards.push({
                title: `No movement S6 → ${SalesFunnelHelper.getStageDisplayCode(EStageId.DEAL_WON)} in 20 days`,
                value: 0,
                emphasis: false,
            })
        }

        return alertCards
    })

    getAlertValueQueryParams(alert: IAlertCard): Record<string, string> {
        if (!alert.leadIds?.length) {
            return {}
        }
        return {
            [LEAD_DASHBOARD_QUERY_PARAMS.LEAD_IDS]: alert.leadIds.join(','),
            [LEAD_DASHBOARD_QUERY_PARAMS.SOURCE]: FUNNEL_SOURCE_HOME,
        }
    }

    // onAlertClick(alert: IAlertCard): void { ... Critical Approvals navigation disabled }

    // isCriticalApprovals(alert: IAlertCard): boolean { ... }
}
